export default "__VITE_ASSET__DqFnbtNG__"